import { SaudiRiyal } from "lucide-react";

export function OrderSummarySkeleton({
  itemsCount = 2
}: { itemsCount?: number } = {}) {
  const items = Array.from({ length: itemsCount }, (_, i) => i + 1);

  return (
    <div className="sticky top-8 hidden rounded-lg p-4 sm:block">
      <div className="space-y-4 p-0">
        {/* Product Items */}
        {items.map((i) => (
          <div
            key={i}
            className={`flex gap-3 ${i < itemsCount ? "border-b border-gray-100 pb-3" : ""}`}
          >
            <div className="relative w-12 shrink-0">
              <div
                className="loading-shimmer aspect-square h-full w-full rounded border border-gray-300 bg-gray-200"
                style={{ animationDelay: `${i * 50}ms` }}
              />
              <div
                className="loading-shimmer absolute -right-1 -top-1 z-10 size-5 rounded-full bg-gray-300"
                style={{ animationDelay: `${i * 50 + 25}ms` }}
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1 space-y-1">
                  <div
                    className="loading-shimmer h-4 w-32 rounded bg-gray-200"
                    style={{ animationDelay: `${i * 50 + 50}ms` }}
                  />
                  <div
                    className="loading-shimmer h-3 w-20 rounded bg-gray-200"
                    style={{ animationDelay: `${i * 50 + 75}ms` }}
                  />
                </div>
                <div className="flex items-center gap-1">
                  <div
                    className="loading-shimmer h-4 w-12 rounded bg-gray-200"
                    style={{ animationDelay: `${i * 50 + 100}ms` }}
                  />
                  <div
                    className="loading-shimmer h-3 w-3 rounded bg-gray-200"
                    style={{ animationDelay: `${i * 50 + 125}ms` }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Coupon Section */}
        <div className="pt-1">
          <div className="space-y-2">
            <div
              className="loading-shimmer h-4 w-16 rounded bg-gray-200"
              style={{ animationDelay: `${itemsCount * 50 + 150}ms` }}
            />
            <div className="flex gap-2">
              <div
                className="loading-shimmer h-8 flex-1 rounded bg-gray-200"
                style={{ animationDelay: `${itemsCount * 50 + 175}ms` }}
              />
              <div
                className="loading-shimmer h-8 w-16 rounded bg-gray-200"
                style={{ animationDelay: `${itemsCount * 50 + 200}ms` }}
              />
            </div>
          </div>
        </div>

        {/* Summary Section */}
        <div className="space-y-1 border-t border-gray-100 pt-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex justify-between">
              <div
                className="loading-shimmer h-4 w-16 rounded bg-gray-200"
                style={{
                  animationDelay: `${itemsCount * 50 + 225 + i * 25}ms`
                }}
              />
              <div className="flex items-center gap-1">
                <div
                  className="loading-shimmer h-4 w-12 rounded bg-gray-200"
                  style={{
                    animationDelay: `${itemsCount * 50 + 225 + i * 25 + 10}ms`
                  }}
                />
                <div
                  className="loading-shimmer h-3 w-3 rounded bg-gray-200"
                  style={{
                    animationDelay: `${itemsCount * 50 + 225 + i * 25 + 15}ms`
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Total Section */}
        <div className="flex justify-between border-t border-gray-200 pt-3">
          <div
            className="loading-shimmer h-5 w-10 rounded bg-gray-200"
            style={{ animationDelay: `${itemsCount * 50 + 325}ms` }}
          />
          <div className="flex items-center gap-1">
            <div
              className="loading-shimmer h-5 w-16 rounded bg-gray-200"
              style={{ animationDelay: `${itemsCount * 50 + 350}ms` }}
            />
            <div
              className="loading-shimmer h-4 w-4 rounded bg-gray-200"
              style={{ animationDelay: `${itemsCount * 50 + 375}ms` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
